import { differenceInHours, parseISO } from 'date-fns';

const REMIND_ME_MIN_HOURS_AHEAD = 2;

export type ShouldShowRemindMeParams = {
  isListed: boolean;
  isProtected: boolean;
  startSalesDateUtc?: string;
};

export function shouldShowRemindMe(params: ShouldShowRemindMeParams): boolean {
  const { isListed, isProtected, startSalesDateUtc } = params;

  if (!isListed || isProtected) return false;
  if (!startSalesDateUtc) return false;

  try {
    const salesStart = parseISO(startSalesDateUtc);
    const hoursUntilStart = differenceInHours(salesStart, new Date());
    return hoursUntilStart > REMIND_ME_MIN_HOURS_AHEAD;
  } catch {
    return false;
  }
}
